import script from "./GreenifiedLoader.vue?vue&type=script&setup=true&lang=ts"
export * from "./GreenifiedLoader.vue?vue&type=script&setup=true&lang=ts"

import "./GreenifiedLoader.vue?vue&type=style&index=0&id=677507d6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-677507d6"]])

export default __exports__